import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const ReturningParty = {
  id: 'returningParty',
  displayName: <FormattedMessage {...messages.returningParty} />,
  type: OptionFormTypes.TYPE_CONTAINS,
  filterValue: 'returnFromName',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CONTAINS, criteriaInformations);
  },
};
